/* eslint-disable quotes */
import ApiService from "./api.service";
// import ApiMockService from "./api.mock.service"

const NutrihubService = {
  // Benefits of Supplements
  getSupplementBenefits: async function (lang = null, params = {}) {
    const response = await ApiService._get("api/nutrihub/benefits", params, lang);
    return response.data;
  },
  getSupplementBenefitById: async function (id, lang = null) {
    const response = await ApiService._get(`api/nutrihub/benefits/${id}?withTranslations=true`, lang);
    return response.data;
  },
  createSupplementBenefit: async function (params = {}, lang = null) {
    const response = await ApiService.post("api/nutrihub/benefits", params, lang);
    return response.data;
  },
  updateSupplementBenefit: async function (id, params = {}, lang = null) {
    const response = await ApiService.put(`api/nutrihub/benefits/${id}`, params, lang);
    return response.data;
  },
  deleteSupplementBenefit: async function (id, lang = null) {
    const response = await ApiService.delete(`api/nutrihub/benefits/${id}`, lang);
    return response.data;
  },

  getSupplementProblems: async function (lang = null, params = {}) {
    const response = await ApiService._get("api/nutrihub/problems", params, lang);
    return response.data;
  },
  getSupplementProblemById: async function (id, lang = null) {
    const response = await ApiService._get(`api/nutrihub/problems/${id}?withTranslations=true`, lang);
    return response.data;
  },
  createSupplementProblem: async function (params = {}, lang = null) {
    const response = await ApiService.post("api/nutrihub/problems", params, lang);
    return response.data;
  },
  updateSupplementProblem: async function (id, params = {}, lang = null) {
    const response = await ApiService.put(`api/nutrihub/problems/${id}`, params, lang);
    return response.data;
  },
  deleteSupplementProblem: async function (id, lang = null) {
    const response = await ApiService.delete(`api/nutrihub/problems/${id}`, lang);
    return response.data;
  },

  // Purposes of Supplements ("Sirve para")
  getPurposes: async function (lang = null, params = {}) {
    const response = await ApiService._get("api/nutrihub/purposes", params, lang);
    return response.data;
  },
  getPurposeById: async function (id, lang = null) {
    const response = await ApiService._get(`api/nutrihub/purposes/${id}?withTranslations=true`, lang);
    return response.data;
  },
  createPurpose: async function (params = {}, lang = null) {
    const response = await ApiService.post("api/nutrihub/purposes", params, lang);
    return response.data;
  },
  updatePurpose: async function (id, params = {}, lang = null) {
    const response = await ApiService.put(`api/nutrihub/purposes/${id}`, params, lang);
    return response.data;
  },
  deletePurpose: async function (id, lang = null) {
    const response = await ApiService.delete(`api/nutrihub/purposes/${id}`, lang);
    return response.data;
  },

  // It is used to create a supplement.
  createSupplement: async function (payload, lang = null) {
    const response = await ApiService.post("api/nutrihub/supplements", payload, lang);
    return response.data;
  },

  // It is used to edit a supplement
  updateSupplement: async function (id, payload) {
    const response = await ApiService.put(`api/nutrihub/supplements/${id}`, payload);
    return response.data;
  },

  // It is used to get all supplements.
  getAllSupplements: async function (params = {}, lang = null) {
    const response = await ApiService._get("api/nutrihub/supplements", params, lang);
    return response.data;
  },

  // It is used to get all supplements in list format.
  getAllSupplementsList: async function (lang = null) {
    const response = await ApiService._get("api/nutrihub/supplements/list", lang);
    return response.data;
  },

  getSupplementById: async function (id, lang = null) {
    const response = await ApiService._get(`api/nutrihub/supplements/${id}?withTranslations=true`, lang);
    return response.data;
  },

  // It is used to delete a supplement.
  remove: async function (id) {
    const response = await ApiService.delete(`api/nutrihub/supplements/${id}`);
    return response.data;
  },
};

export default NutrihubService;
